import React, { useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/ui/Footer";
import NavbarHome from "../../components/ui/NavbarHome";
import "../../components/styles/common.css"
const CookiePolicy = () => {

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  });

  const requiredCookies = [
    [
      "Cloudflare",
      "3rd party",
      "Cloudflare protects our customer’s sites from malicious traffic and spam across our site. We use this cookie to identify individual clients behind a shared IP address and apply security settings.",
      "1 year",
    ],
    [
      "Gid",
      "No third party involved",
      "This cookie assists us in identifying visitors and accurately measuring the total number of users visiting our site from various locations on the internet.",
      "1 year",
    ],
    [
      "Gid_tmp",
      "No third parties involved",
      "This cookie assists us in identifying our visitors and allows us to accurately measure the total number of individuals visiting our site from various locations on the internet. ",
      "1 year",
    ],
    [
      "Jsessionid",
      "New Relic",
      "This cookie is used to track sessions. This assists us in monitoring the reliability of our services. They also benefit in the management of login sessions by sustaining user states across page requests.",
      "",
    ],
    [
      "Veriff",
      "Veriff",
      "Identity verification ensures that a real person is behind a process and that they are whom they say they are. This prevents anyone from acting on behalf of others without authorization, creating false identities, or committing fraud. Therefore, we use veriff cookies to detect any fraudulent or unlawful activity by a user.",
      "1 year",
    ],
    [
      "twCookiesCOnsent",
      "",
      "This is essential for letting us remember your choice of cookie consent.",
      "6 months",
    ],
    [
      "twCookiesCOncentGTM",
      "",
      "This is essential for letting us remember your choice of cookie consent.",
      "6 months",
    ],
    [
      "_mp_opt_in_out",
      "Mixpanel",
      "This is essential for letting us remember your choice of cookie consent, especially for mixpanel.",
      "N/A",
    ],
  ];

  return (
    <div className="font-nunito">
      <NavbarHome />
      <main className="bg-white mt-24 relative w-full sm:w-4/5 flex flex-col gap-8 justify-center items-center m-auto mb-10 py-10 px-8 text-lg">
        <h1 className="font-bold text-3xl">Cookies Policy</h1>
        <p className="mt-6">
          This cookie statement describes how ScopeX recognizes you when you
          visit our website at{" "}
          <Link to="/" className="underline" data-test="scopex">
            {" "}
            ScopeX
          </Link>{" "}
          by using cookies and other similar technologies. It describes these
          technologies, why we use them, and your rights to limit how we use
          them. In rare circumstances, we could use cookies to gather
          information about you that could constitute personal information if
          combined with other data. Cookies help us provide you with a better
          browsing experience, enhance the caliber of our services, and reduce
          our marketing costs. They enable us to make logging in simpler and
          they help us identify potential problems with our products. Without
          them, we wouldn't be able to keep track of things about you, such as
          whether you are logged in.
        </p>
        <section className="flex flex-col gap-2">
          <h2 className="text-2xl font-semibold ">What are cookies?</h2>
          <p>
            When you visit a website, little data files called cookies are
            downloaded to your computer or mobile device. Website owners
            frequently employ cookies to help their websites function and to
            collect reporting data. First-party cookies are those placed by the
            website owner, and third-party cookies are those placed by parties
            other than the website owner. The provision of third-party services
            or functionality on the website is made possible by third-party
            cookies (e.g. advertising, interactive content, and analytics). The
            parties who place these third-party cookies can identify your
            computer when it visits the website above and a few other websites.
          </p>
        </section>
        <section className="flex flex-col gap-2">
          <h2 className="font-semibold text-2xl ">Why do we use cookies?</h2>
          <p>
            There are several reasons why we utilize first-party and third-party
            cookies. We refer to some cookies as "important" or "strictly
            necessary" cookies since they are vital for our websites to function
            technically. To improve the user experience on our online domains,
            we can track and target the interests of our users using additional
            cookies. Through our websites, third parties provide cookies for
            advertising, analytics, and other uses.
          </p>
          <p className="">
            Three types of cookies may be used during your visits to the ScopeX
            website:
          </p>
          <ul className="list-disc list-inside">
            <li>
              <h3 className="inline font-semibold">Transactional cookies </h3>
              <p className="inline">
                These are the cookies needed for necessary functions on your
                website visit. The processing of transactions, determining which
                website version you are using (such as mobile or desktop), fraud
                detection and prevention, and facilitating compliance and
                website stability are a few of these.
              </p>
            </li>
            <li>
              <h3 className="inline font-semibold">Performance cookies </h3>
              <p className="inline">
                These cookies gather data on how well our website performs and
                how you use it, such as the pages you visit and whether you
                encounter any mistakes. This data helps ScopeX diagnose website
                issues and analyzes how frequently certain website sections are
                used. These cookies often gather anonymous, statistical data.
                All information is kept private and is only used to better
                understand your interests, enhance your website experience, and
                assess the success of our marketing strategies.
              </p>
            </li>
            <li>
              <h3 className="inline font-semibold">Marketing cookies </h3>
              <p className="inline">
                These cookies are linked to services offered by ScopeX and third
                parties, such as surveys, marketing requests, and "Like" and
                "Share" buttons from third parties, such as linking to social
                network sites, who may subsequently use information about your
                visit. They also help us market to you, measure the success of
                marketing, and provide you with marketing.
              </p>
            </li>
          </ul>
        </section>
        <section className="flex flex-col gap-2">
          <h2 className="font-semibold text-2xl">Essential website cookies</h2>
          <p className="">
            These cookies are strictly necessary to provide you with services
            available through our websites and to use some of its features, such
            as access to secure areas.
          </p>
          <table className="table-fixed border-collapse border overflow-x-auto w-full text-xs lg:text-base">
            <thead>
              <tr>
                <td className="border p-4 font-semibold">COOKIE NAME</td>
                <td className="border p-4 font-semibold">COOKIE TYPE</td>
                <td className="border p-4 font-semibold">PURPOSE</td>
                <td className="border p-4 font-semibold">LIFESPAN</td>
              </tr>
            </thead>
            <tbody>
              {requiredCookies.map((cookie) => (
                <tr>
                  <td className="border p-4">{cookie[0]}</td>
                  <td className="border p-4">{cookie[1]}</td>
                  <td className="border p-4">{cookie[2]}</td>
                  <td className="border p-4">{cookie[3]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
        <section className="flex flex-col gap-2">
          <h2 className="font-semibold text-2xl">How can I control cookies?</h2>
          <p>
            The choice of accepting or rejecting cookies is entirely up to you.
            You may choose which categories of cookies you accept or refuse
            using the cookie consent manager. Since they are completely
            necessary to provide you with services, essential cookies cannot be
            denied.
          </p>
          <p>
            You may still use our website even if you decide to reject cookies,
            but certain functionality and access to some parts of it may be
            limited. You should check your browser's help menu for further
            information since the methods for rejecting cookies through your web
            browser options differ from browser to browser. By turning on the
            browser options that let you deny the setting of all or specific
            cookies, you can decide to prevent cookies. However, you might not
            be able to access some areas of the website if you use your
            browser's settings to prevent all cookies (including necessary
            cookies). Additionally, you can always erase all cookies saved on
            your device using your browser's settings.
          </p>
          <p>
            If you are concerned about online tracking then we can recommend
            you:
          </p>
          <ul className="list-disc list-inside">
            <li>
              To Install a privacy-friendly browser on your devices, such as
              Mozilla Firefox, Firefox Focus, or Brave;
            </li>
            <li>
              Install anti-tracking and ad-blocking plug-ins on that browser
              and,
            </li>
            <li>Use privacy-friendly web search engines.</li>
          </ul>
        </section>
        <section className="flex flex-col gap-2">
          <h3 className="font-semibold text-2xl">Keeping you updated</h3>
          <p>
            We update our policies from time to time to reflect, for example,
            changes to the cookies we use or for other operational, legal, or
            regulatory reasons. Please, therefore, revisit this cookie policy
            from time to time to stay informed about the changes.
          </p>
          <p>
            The date at the top of this cookie policy indicates when it was last
            updated.
          </p>
          <p>Where can I get further information?</p>
          <p>
            If you have any queries regarding the use of our cookies and other
            technologies, please{" "}
            <Link to="/Contact" className="underline" data-test="contact">
              contact us
            </Link>
          </p>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default CookiePolicy;
